import { useEffect, useState } from 'react';
import './index.css';

const GameLoader = ({ gameLogo }: any) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const setTimerInterval = setInterval(() => {
      if (percentage !== 100) {
        setPercentage(percentage + 1);
      }
    }, 100);
    return () => {
      clearInterval(setTimerInterval);
    };
  });

  return (
    <div className="gameLoader__container ">
      <div className="gameLoader__wrapper">
        <img className="gameLoader__logo" src={gameLogo} alt="" />
        {'Loading Game...'}
        <div className="gameLoader__progressWrapper">
          <div style={{ width: percentage + '%' }} className="gameLoader__progressBar"></div>
        </div>
      </div>
    </div>
  );
};

export default GameLoader;
